<div class="gold-upgrade-right back-btn" (click)="goHomeAction()">
  <h2
    class="title"
    [innerHTML]="'plan.upgrade.more.desc' | translate"
    [style]="'fontSize.48' | translate"
  ></h2>
  <p class="description" [style]="'fontSize.28' | translate">
    {{ "plan.here.how.upgrade" | translate }}
  </p>
  <p class="steps-title" [style]="'fontSize.28' | translate">
    {{ "plan.steps.upgrade" | translate }}
  </p>
  <ul class="steps" [style]="'fontSize.24' | translate">
    <li>{{ "plan.website" | translate }}</li>
    <li>{{ "plan.settings.sign" | translate }}</li>
    <li>{{ "plan.subscription_detail" | translate }}</li>
    <li>{{ "plan.select.upgrade.plan" | translate }}</li>
  </ul>
  <app-icon-button [label]="label"></app-icon-button>
</div>
